import { render, staticRenderFns } from "./CompanionCard.vue?vue&type=template&id=bbef4138&scoped=true"
import script from "./CompanionCard.vue?vue&type=script&lang=js"
export * from "./CompanionCard.vue?vue&type=script&lang=js"
import style0 from "./CompanionCard.vue?vue&type=style&index=0&id=bbef4138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbef4138",
  null
  
)

export default component.exports